export default {"src":"/_next/static/media/qwiz-dark.8681b564.svg","height":245,"width":413};